import { render } from "./Vip.vue?vue&type=template&id=742d5802"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Vip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "742d5802"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('742d5802', __exports__)) {
    api.reload('742d5802', __exports__)
  }
  
  module.hot.accept("./Vip.vue?vue&type=template&id=742d5802", () => {
    api.rerender('742d5802', render)
  })

}


export default __exports__